"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.MainMenuModuleDefinition = exports.Menu = exports.renderMenu = void 0;
var React = __importStar(require("react"));
var Icon_1 = __importDefault(require("../../Icon/Icon"));
var LinkMenuItem_1 = require("../menu/LinkMenuItem");
var SubMenuItem_1 = require("../menu/SubMenuItem");
function renderMenu(path, items, slim, state, dispatch, navigate) {
    return (React.createElement(React.Fragment, null, items.map(function (item) { return item.render({
        path: path + "." + item.name,
        slim: slim,
        state: state,
        dispatch: dispatch,
        navigate: navigate,
    }); })));
}
exports.renderMenu = renderMenu;
function menuReducer(state, action) {
    var newState = Object.assign({}, state);
    if (action.type === 'set-active-path') {
        newState.activePath = action.path;
    }
    else if (action.type === 'set-navigation-path') {
        newState.navigationPath = action.path;
    }
    return newState;
}
var Menu = function (_a) {
    var menuItems = _a.menuItems, accountMenuItems = _a.accountMenuItems, user = _a.user, expandingOrCollapsing = _a.expandingOrCollapsing, slim = _a.slim, currentPath = _a.currentPath, strings = _a.strings, navigate = _a.navigate;
    // navigationPath and activePath are two dot-delimited path's referencing a menu item
    // They are created by concatenating the name fields of all the menu/sub-menu items leading to the relevant one.
    // For example, the "Users" item in the "Settings" sub-menu would have the path 'settings.users'
    // - navigationPath references the current sub-menu that the user currently has open
    // - activePath references the menu item for the the page the user is currently on
    var _b = __read(React.useReducer(menuReducer, {
        navigationPath: '',
        activePath: '',
    }), 2), state = _b[0], dispatch = _b[1];
    var accountSettingsOpen = state.navigationPath.startsWith('.account');
    // Whenever currentPath or menu changes, work out new activePath
    React.useEffect(function () {
        var urlPathsToNavigationPaths = [];
        var walkMenu = function (path, walkingMenuItems) {
            walkingMenuItems.forEach(function (item) {
                var newPath = path + "." + item.name;
                if (item instanceof LinkMenuItem_1.LinkMenuItemDefinition) {
                    urlPathsToNavigationPaths.push([item.url, newPath]);
                }
                else if (item instanceof SubMenuItem_1.SubMenuItemDefinition) {
                    walkMenu(newPath, item.menuItems);
                }
            });
        };
        walkMenu('', menuItems);
        walkMenu('', accountMenuItems);
        var bestMatch = null;
        urlPathsToNavigationPaths.forEach(function (_a) {
            var _b = __read(_a, 2), urlPath = _b[0], navPath = _b[1];
            if (currentPath.startsWith(urlPath)) {
                if (bestMatch == null || urlPath.length > bestMatch[0].length) {
                    bestMatch = [urlPath, navPath];
                }
            }
        });
        var newActivePath = bestMatch ? bestMatch[1] : '';
        if (newActivePath !== state.activePath) {
            dispatch({
                type: 'set-active-path',
                path: newActivePath,
            });
        }
    }, [currentPath, menuItems]);
    React.useEffect(function () {
        // Close submenus when user presses escape
        var onKeydown = function (e) {
            // IE11 uses "Esc" instead of "Escape"
            if (e.key === 'Escape' || e.key === 'Esc') {
                dispatch({
                    type: 'set-navigation-path',
                    path: ''
                });
            }
        };
        var onClickOutside = function (e) {
            var sidebar = document.querySelector('[data-wagtail-sidebar]');
            var isInside = sidebar && sidebar.contains(e.target);
            if (!isInside) {
                dispatch({
                    type: 'set-navigation-path',
                    path: ''
                });
            }
        };
        document.addEventListener('keydown', onKeydown);
        document.addEventListener('mousedown', onClickOutside);
        document.addEventListener('touchend', onClickOutside);
        return function () {
            document.removeEventListener('keydown', onKeydown);
            document.removeEventListener('mousedown', onClickOutside);
            document.removeEventListener('touchend', onClickOutside);
        };
    }, []);
    // Whenever the parent Sidebar component collapses or expands, close any open menus
    React.useEffect(function () {
        if (expandingOrCollapsing) {
            dispatch({
                type: 'set-navigation-path',
                path: ''
            });
        }
    }, [expandingOrCollapsing]);
    var onClickAccountSettings = function (e) {
        e.preventDefault();
        if (accountSettingsOpen) {
            dispatch({
                type: 'set-navigation-path',
                path: '',
            });
        }
        else {
            dispatch({
                type: 'set-navigation-path',
                path: '.account',
            });
        }
    };
    var className = ('sidebar-main-menu'
        + (accountSettingsOpen ? ' sidebar-main-menu--open-footer' : ''));
    return (React.createElement(React.Fragment, null,
        React.createElement("nav", { className: className, "aria-label": strings.MAIN_MENU },
            React.createElement("ul", { className: "sidebar-main-menu__list" }, renderMenu('', menuItems, slim, state, dispatch, navigate))),
        React.createElement("div", { className: 'sidebar-footer' + (accountSettingsOpen ? ' sidebar-footer--open' : '') },
            React.createElement("button", { className: "sidebar-footer__account", title: strings.EDIT_YOUR_ACCOUNT, "aria-label": strings.EDIT_YOUR_ACCOUNT, onClick: onClickAccountSettings, "aria-haspopup": "true", "aria-expanded": accountSettingsOpen ? 'true' : 'false' },
                React.createElement("div", { className: "avatar square avatar-on-dark" },
                    React.createElement("img", { src: user.avatarUrl, alt: "" })),
                React.createElement("div", { className: "sidebar-footer__account-toggle" },
                    React.createElement("div", { className: "sidebar-footer__account-label" }, user.name),
                    React.createElement(Icon_1["default"], { className: "sidebar-footer__account-icon", name: (accountSettingsOpen ? 'arrow-down' : 'arrow-up') }))),
            React.createElement("ul", null, renderMenu('', accountMenuItems, slim, state, dispatch, navigate)))));
};
exports.Menu = Menu;
var MainMenuModuleDefinition = /** @class */ (function () {
    function MainMenuModuleDefinition(menuItems, accountMenuItems, user) {
        this.menuItems = menuItems;
        this.accountMenuItems = accountMenuItems;
        this.user = user;
    }
    MainMenuModuleDefinition.prototype.render = function (_a) {
        var slim = _a.slim, expandingOrCollapsing = _a.expandingOrCollapsing, key = _a.key, currentPath = _a.currentPath, strings = _a.strings, navigate = _a.navigate;
        return (React.createElement(exports.Menu, { menuItems: this.menuItems, accountMenuItems: this.accountMenuItems, user: this.user, slim: slim, expandingOrCollapsing: expandingOrCollapsing, key: key, currentPath: currentPath, strings: strings, navigate: navigate }));
    };
    return MainMenuModuleDefinition;
}());
exports.MainMenuModuleDefinition = MainMenuModuleDefinition;
